import React, { ReactNode } from 'react';
import classNames from 'classnames';
import Text from '../text/Text';
import { Button } from '../button';

export interface DropdownItemProps {
  id?: string | number;
  testId?: string;
  icon?: ReactNode;
  name?: string | ReactNode;
  url?: string;
  commandIcon?: ReactNode;
  commandLabel?: string;
  hr?: boolean;
  onClick?: () => void;
  hide?: boolean;
  show?: boolean;
  isButton?: boolean;
  buttonType?: 'button' | 'submit';
  disabled?: boolean;
}

const DropdownItem = ({
  testId,
  icon,
  name,
  commandIcon,
  commandLabel,
  hr,
  onClick,
  isButton,
  buttonType = 'button',
  disabled,
}: DropdownItemProps) => {
  const Item = () => (
    <>
      <div className="d-flex gap-2 align-items-center">
        <span className="d-flex justify-content-center">{icon}</span>
        <Text color="title" size="sm" weight="medium">
          {name}
        </Text>
      </div>
      <div className="d-flex align-items-center">
        {commandIcon && (
          <span className="d-flex justify-content-center">{commandIcon}</span>
        )}
        {commandLabel && (
          <Text color="subtitle2" size="xs">
            {commandLabel}
          </Text>
        )}
      </div>
    </>
  );

  if (isButton) {
    return (
      <Button
        htmlType={buttonType}
        data-testid={testId}
        className={classNames(
          'd-flex',
          'gap-10',
          'justify-content-between',
          'pointer',
          'p-6',
          'w-100',
          { 'border-bottom': hr },
        )}
        {...(onClick && {
          onClick: onClick,
        })}
        disabled={disabled}
      >
        <Item />
      </Button>
    );
  }

  return (
    <div
      data-testid={testId}
      className={classNames(
        'd-flex',
        'gap-10',
        'justify-content-between',
        'pointer',
        'p-6',
        { 'border-bottom': hr },
        { 'opacity-50': disabled },
      )}
      {...(onClick &&
        !disabled && {
          onClick: onClick,
        })}
    >
      <Item />
    </div>
  );
};
export default DropdownItem;
